import React, { Component } from "react";
import { render } from "react-dom";
import { formatNumber } from "@telerik/kendo-intl";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { ValueTypeEnum, ButtonMessageEnum } from "../../../enums";
import { Form, Field } from "react-final-form";
import { Input, NumericTextBox, MaskedTextBox } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { LocalizationService } from "@progress/kendo-react-intl";
import Moment from "moment";
import { logController } from "../../../controllers/log.controller";

let resolve;

const kendoHOC = (type, { input, meta, label, ...rest }) => {
    const Type = type;
    const LabelElement = "label";
    //const LabelElement = type !== DatePicker ? "label" : "span";
    if (type === NumericTextBox && input.value === "") {
        input.value = null;
    }
    return (
        <LabelElement className="k-form-field">
            <span>{label}</span>
            <Type {...input} {...rest} />
            {meta.error && meta.touched && <span className="k-required">{meta.error}</span>}
        </LabelElement>
    );
};
const KendoInput = options => kendoHOC(Input, options);
const KendoNumeric = options => kendoHOC(NumericTextBox, options);
const KendoMaskedEdit = options => kendoHOC(MaskedTextBox, options);

export class PromptDialog extends Component {
    static create(props = {}) {
        const containerElement = document.createElement("div");
        document.body.appendChild(containerElement);
        return render(<PromptDialog createPromptProps={props} />, containerElement);
    }

    constructor() {
        super();

        this.state = {
            isOpen: false,
            showPromptProps: {}
        };

        this.handleCancel = this.handleCancel.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.show = this.show.bind(this);
    }

    formValidation = values => {
        const errors = {};

        var selectedLanguage = localStorage.getItem("selectedLanguage");
        var localizationService = new LocalizationService(selectedLanguage);

        if (!values.value) {
            errors.value = localizationService.toLanguageString("PromptDialog.Vyžaduje sa zadanie hodnoty.", "Vyžaduje sa zadanie hodnoty.");
        } else if (values.valueType == ValueTypeEnum.DATE) {
            var date = Moment(values.value, "D.M.YYYY", true);
            if (!date.isValid()) {
                errors.value = localizationService.toLanguageString(
                    "PromptDialog.Dátum nie je zadaný v správnom formáte.",
                    "Dátum nie je zadaný v správnom formáte."
                );
            }
        } else if (values.valueType == ValueTypeEnum.DATETIME) {
            var date = Moment(values.value, "D.M.YYYY H:mm", true);
            if (!date.isValid()) {
                errors.value = localizationService.toLanguageString(
                    "PromptDialog.Dátum a čas nie je zadaný v správnom formáte.",
                    "Dátum a čas nie je zadaný v správnom formáte."
                );
            }
        } else if (values.valueType == ValueTypeEnum.NUMBER) {
            if (isNaN(values.value)) {
                errors.value = localizationService.toLanguageString(
                    "PromptDialog.Číslo nie je zadané v správnom formáte.",
                    "Číslo nie je zadané v správnom formáte."
                );
            }
        }

        return errors;
    };

    handleCancel() {
        this.setState({ isOpen: false });
        if (this.state.showPromptProps.logMessage == true) {
            logController.logMessage(`${this.state.showPromptProps.message} => ${ButtonMessageEnum.CANCEL}`);
        }
        resolve({ button: ButtonMessageEnum.CANCEL });
    }

    handleOnSubmit(values) {
        this.setState({ isOpen: false });
        if (this.state.showPromptProps.logMessage == true) {
            logController.logMessage(`${this.state.showPromptProps.message} => ${ButtonMessageEnum.OK} (${values.value})`);
        }
        resolve({ button: ButtonMessageEnum.OK, value: values.value });
    }

    show(props = {}) {
        const showPromptProps = { ...this.props.createPromptProps, ...props };
        this.setState({ isOpen: true, showPromptProps: showPromptProps });

        var autoFocus = document.getElementById("PromptDialogForm");
        if (autoFocus) {
            autoFocus = autoFocus.getElementsByTagName("input")[0];
            if (autoFocus) {
                autoFocus.focus();
            }
        }

        return new Promise(res => {
            resolve = res;
        });
    }

    render() {
        var selectedLanguage = localStorage.getItem("selectedLanguage");
        var localizationService = new LocalizationService(selectedLanguage);

        const defaultProps = {
            title: localizationService.toLanguageString("PromptDialog.Zadajte hodnotu", "Zadajte hodnotu"),
            message: localizationService.toLanguageString("PromptDialog.Zadajte hodnotu", "Zadajte hodnotu") + ":",
            valueType: ValueTypeEnum.TEXT
        };

        const { isOpen, showPromptProps } = this.state;
        const { message, title, valueType, ...rest } = showPromptProps;

        var component = KendoInput;
        var mask = null;
        if (valueType == ValueTypeEnum.DATE || valueType == ValueTypeEnum.DATETIME) {
            component = KendoMaskedEdit;
            mask = valueType == ValueTypeEnum.DATETIME ? "90.90.0000 90:00" : "90.90.0000";
        }
        // else if (valueType == ValueTypeEnum.NUMBER) {
        //     component = KendoNumeric;
        // }

        return isOpen ? (
            <div id="PromptDialogForm">
                <Dialog title={title || defaultProps.title} onClose={this.handleCancel}>
                    <Form
                        validate={this.formValidation}
                        onSubmit={values => this.handleOnSubmit(values)}
                        initialValues={{ value: null, valueType: valueType }}
                        render={({ form, handleSubmit, submitting, pristine }) => (
                            <React.Fragment>
                                <form onSubmit={handleSubmit} className="k-form">
                                    <fieldset>
                                        <Field name="value" label={message || defaultProps.message} component={component} mask={mask} />
                                    </fieldset>
                                </form>
                                <DialogActionsBar>
                                    <Button
                                        icon="check"
                                        className="font-bold"
                                        primary={true}
                                        type="submit"
                                        onClick={handleSubmit}
                                        disabled={submitting || pristine}>
                                        OK
                                    </Button>
                                    <Button className="font-bold" onClick={this.handleCancel}>
                                        Zrušit
                                    </Button>
                                </DialogActionsBar>
                            </React.Fragment>
                        )}
                    />
                </Dialog>
            </div>
        ) : (
            <React.Fragment />
        );
    }
}

export default PromptDialog;



// WEBPACK FOOTER //
// ./src/components/common/promptService/PromptDialog.js